import script from "./DeveloperFeedback.vue?vue&type=script&setup=true&lang=js"
export * from "./DeveloperFeedback.vue?vue&type=script&setup=true&lang=js"

import "./DeveloperFeedback.vue?vue&type=style&index=0&id=9b43b722&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b43b722"]])

export default __exports__